export default class {
    static projectName = "Aahilya Holidays";
    static userData = "USER_DATA";
    static themeColor = '#35b5ac';


    static emailRjx = /\S+@\S+\.\S+/;
}